// extracted by mini-css-extract-plugin
export default {"input-group":"InputGroup_input-group__Sqc+K"};